import React from 'react';
import { useSelector } from 'react-redux';
import { selectDataForRecommendedProduct } from 'formal_quote/inline_formal_quote/redux/selectors';

const RecommendedProduct = (props) => {
  const { title = 'Recommended Product' } = props;
  const data = useSelector(selectDataForRecommendedProduct);

  const renderColumn = (label, value) => {
    if (!value) return null;

    return (
      <div className="flex-column text-nowrap">
        <div className="label">{label}</div>
        <div className="value">{value}</div>
      </div>
    );
  };

  return (
    <div className="recommended-product">
      <div className="title">{title}</div>
      <div className="container-fluid selection-box">
        <div className="row flex-row">
          {renderColumn('Product', data.productName)}
          {renderColumn('Quote Type', data.licenseScope)}
          {renderColumn(data.numberOfUsersLabel, data.numberOfUsers)}
          {renderColumn('License Type', data.licenseType)}
          {renderColumn('Delivery Method', data.deliveryMethod)}
        </div>
      </div>
      <p className="text-muted mt-2">
        To change the License Type, click the options at the top of the page.
      </p>
    </div>
  );
};

export default RecommendedProduct;
